import React from "react";
import { Button, useColorModeValue } from "@chakra-ui/react";
import { ButtonProps } from "@chakra-ui/button/dist/types/button";

import { useGetThemeColors } from "ChakraTheme";

interface IProps extends ButtonProps {}

const RedButton = React.forwardRef<HTMLButtonElement, IProps>(
  ({ children, ...props }, ref) => {
    const colors = useGetThemeColors();
    const textColor = useColorModeValue(colors.white, colors.black);

    const backgroundBtnColor = useColorModeValue(
      colors.red[600],
      colors.red[300]
    );
    const hoverBackgroundBtnColor = useColorModeValue(
      colors.red[700],
      colors.red[400]
    );

    const activeBackgroundBtnColor = useColorModeValue(
      colors.red[800],
      colors.red[500]
    );

    return (
      <Button
        ref={ref}
        color={textColor}
        bg={backgroundBtnColor}
        _hover={{
          bg: hoverBackgroundBtnColor,
        }}
        _active={{
          bg: activeBackgroundBtnColor,
        }}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

export { RedButton };
